import {
  GET_MANAGE_WORK,
  UPDATE_MANAGE_WORK,
  DELETE_MANAGE_WORK,
  ADD_MANAGE_WORK,
} from "../type";
const initialState = {
  AddManagework: [],
  GetManagework: [],
  DeleteManagework: [],
  UpdateManagework: [],
  loading: true,
};
const ManageWorkR = (state = initialState, action) => {
  switch (action.type) {
    case GET_MANAGE_WORK:
      return {
        ...state,
        GetManagework: action.payload,
        loading: false,
      };
    case ADD_MANAGE_WORK:
      return {
        GetManagework: state.GetManagework,
        AddManagework: action.payload,
        loading: false,
      };
    case DELETE_MANAGE_WORK:
      return {
        GetManagework: state.GetManagework,
        DeleteManagework: action.payload,
        loading: false,
      };
    case UPDATE_MANAGE_WORK:
      return {
        GetManagework: state.GetManagework,
        UpdateManagework: action.payload,
        loading: false,
      };
    default:
      return state;
  }
};
export default ManageWorkR;
